import React from 'react';
import { Box, useTheme } from '@mui/material';
import { imgUploadStyle } from 'pages/Forms/Theme/responseInputStyles';
import { HyperLink } from 'components/atoms';

interface Photo {
  id: string;
  file: string;
  name: string;
}

interface ImageComponentProps {
  photo: Photo;
}

export const ImageComponent: React.FC<ImageComponentProps> = ({ photo }) => {
  const theme = useTheme();

  return (
    <Box
      mt={1}
      key={photo.id}
      border={`1px dashed ${
        theme.palette.other?.border || theme.palette.divider
      }`}
      p={0.5}
      borderRadius={1}
    >
      <HyperLink href={photo?.file} target="_blank">
        <img src={photo.file} alt={photo.name} style={imgUploadStyle} />
      </HyperLink>
    </Box>
  );
};
